import type { IconProps } from "./icon-types";

/**
 * 계기판(아래가 열린 약 270° 호 + 중심점 + 우상단 바늘). 성능 지표/메트릭 표시에 사용
 * (제품 의미 부여는 소비 앱의 semantic alias 책임).
 *
 * 커스텀 드로잉 — c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split
 * §아이콘). 24 그리드 / stroke 기반. 눈금은 16px 에서 뭉쳐 넣지 않는다.
 */
export const GaugeIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M5.64 19.36A9 9 0 1 1 18.36 19.36" />
    <path d="M12 13l4.2-4.2" />
    <circle cx="12" cy="13" r="1" />
  </svg>
);
